import React from 'react';
import { practiceModel, practiceNotes } from '../data/mock';
import { Home, Video, UserCheck, Clock, AlertCircle } from 'lucide-react';

const Practice = () => {
  const features = [
    {
      icon: Home,
      title: 'Home Visits',
      description: 'Medical care delivered to your residence or accommodation'
    },
    {
      icon: Video,
      title: 'Telemedicine',
      description: 'Secure remote consultations from anywhere'
    },
    {
      icon: UserCheck,
      title: 'Discreet Care',
      description: 'Privacy and confidentiality guaranteed'
    },
    {
      icon: Clock,
      title: 'Appointment-Based',
      description: 'Scheduled consultations for your convenience'
    }
  ];

  return (
    <section id="practice" className="section-padding bg-[#f8fafc]">
      <div className="container">
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <p className="text-sm uppercase tracking-widest text-[#b8860b] font-medium mb-4">
              Practice Model
            </p>
            <h2 className="heading-1 text-[#0f172a] mb-4">
              {practiceModel.title}
            </h2>
            <p className="body-large text-[#475569] max-w-2xl mx-auto">
              {practiceModel.description}
            </p>
            <p className="text-base italic text-[#64748b] mt-4">
              {practiceModel.tagline}
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {features.map((feature, index) => (
              <div key={index} className="text-center p-8 bg-white border border-[#e2e8f0] hover-lift">
                <div className="inline-flex items-center justify-center w-14 h-14 border-2 border-[#0f172a] mb-5">
                  <feature.icon size={24} className="text-[#0f172a]" />
                </div>
                <h3 className="text-base font-semibold text-[#0f172a] mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-[#64748b]">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>

          {/* Practice Notes */}
          <div className="border-2 border-[#0f172a] p-8 bg-white">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-[#0f172a] flex items-center justify-center flex-shrink-0">
                <AlertCircle size={20} className="text-white" />
              </div>
              <div>
                <h4 className="text-base font-semibold text-[#0f172a] mb-4">
                  Important Practice Notes
                </h4>
                <ul className="space-y-2">
                  {practiceNotes.map((note, index) => (
                    <li key={index} className="text-sm text-[#475569] flex items-start gap-2">
                      <span className="text-[#b8860b]">•</span>
                      {note}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Practice;
